/* eslint-disable no-undef */
import { unwrapNodes } from "@/helpers/graphql";
import * as Sentry from "@sentry/vue";

export const addToCartEvent = async ({ sku, quantity, cart }) => {
  const cartLines = unwrapNodes(cart.lines.edges);

  updateCartEvent(cart);

  const { merchandise } = cartLines.find((line) => line.merchandise.id === sku);
  const merchandiseId = merchandise.product.id;
  const productId = merchandiseId.split("Product/")[1];

  const eventId = "RAB_" + new Date().getTime() + "_" + sku;

  const body = JSON.stringify({
    sku: productId,
    quantity,
    url: merchandise.product.onlineStoreUrl,
    price: merchandise.priceV2.amount,
    currency: merchandise.priceV2.currencyCode,
    eventId,
  });

  // eslint-disable-next-line no-undef
  fbq(
    "track",
    "AddToCart",
    {
      content_type: "product_group",
      content_ids: [productId],
      value: merchandise.priceV2.amount,
      num_items: quantity,
      content_name: merchandise.product.title,
      currency: merchandise.priceV2.currencyCode,
    },
    {
      eventID: eventId,
    }
  );

  const imageUrl = unwrapNodes(merchandise.product.images.edges)[0].klaviyo;

  const collections = unwrapNodes(merchandise.product.collections.edges);
  const collectionTitles = collections.map((collection) => collection.title);

  const item = {
    Name: merchandise.product.title,
    ProductID: productId,
    Categories: collectionTitles,
    ImageURL: imageUrl,
    URL: merchandise.product.onlineStoreUrl,
    Brand: merchandise.product.vendor,
    Price: merchandise.priceV2.amount,
    CompareAtPrice:
      merchandise.product.compareAtPriceRange.minVariantPrice.amount,
  };

  _learnq.push(["track", "Added to Cart", item]);

  console.log(_learnq.push(["track", "Added to Cart", item]));

  const addToCart = (merchandise, productId) => {
    const item = {
      item_name:
        merchandise.product.title +
        ` - ` +
        merchandise.selectedOptions[0].value,
      item_id:
        `shopify_US_` +
        productId +
        `_` +
        merchandise.id.split("ProductVariant/")[1],
      price: merchandise.priceV2.amount,
      item_brand: merchandise.product.vendor,
      item_category: merchandise.product.productType,
      item_variant: merchandise.selectedOptions[0].value,
      quantity: "1",
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        items: [item],
      },
    });
  };

  addToCart(merchandise, productId);

  window.VWO = window.VWO || [];
  VWO.event =
    VWO.event ||
    function () {
      VWO.push(["event"].concat([].slice.call(arguments)));
    };
  VWO.event("addedToCart", {
    added_to_cart: true,
  });

  console.log("Add to cart VWO event");

  await fetch(`${process.env.RATANDBOA_NODE_APP_URL}/event`, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body,
  });
};

export const updateCartEvent = async (cart) => {
  const cartLines = unwrapNodes(cart.lines.edges);

  const items = [];
  cartLines.forEach((line) => {
    const productId = line.merchandise.product.id;
    const merchandiseId = line.merchandise.id;
    items.push({
      name: line.merchandise.product.title,
      price_currency_code: line.merchandise.priceV2.currencyCode,
      product_id: productId.split("Product/")[1],
      quantity: 1,
      sku_id: merchandiseId.split("ProductVariant/")[1],
      unit_price: line.merchandise.priceV2.amount,
    });
  });

  // eslint-disable-next-line no-undef
  nostojs((api) => {
    api.defaultSession().setCart({
      items,
    });
  });
};

export const viewFrontPageEvent = async () => {
  // eslint-disable-next-line no-undef
  nostojs((api) => {
    api
      .defaultSession()
      .viewFrontPage()
      .setPlacements(api.placements.getPlacements())
      .load()
      .then((data) => {
        console.log(data.recommendations);
      });
  });
};

export const viewProductEvent = async (product) => {
  const productId = product.id.split("Product/")[1];
  const imageUrl = unwrapNodes(product.images.edges)[0].largeMedia;

  const collections = unwrapNodes(product.collections.edges);
  const collectionTitles = collections.map((collection) => collection.title);

  const firstVariantPrice = unwrapNodes(product.variants.edges)[0].priceV2
    .amount;

  const item = {
    Name: product.title,
    ProductID: productId,
    Categories: collectionTitles,
    ImageURL: imageUrl,
    URL: product.onlineStoreUrl,
    Brand: product.vendor,
    Price: firstVariantPrice,
    CompareAtPrice: product.compareAtPriceRange.minVariantPrice.amount,
  };

  _learnq.push(["track", "Viewed Product", item]);
  _learnq.push([
    "trackViewedItem",
    {
      Title: item.Name,
      ItemId: item.ProductID,
      Categories: item.Categories,
      ImageUrl: item.ImageURL,
      Url: item.URL,
      Metadata: {
        Brand: item.Brand,
        Price: item.Price,
        CompareAtPrice: item.CompareAtPrice,
      },
    },
  ]);
};

export const viewCollectionEvent = async (collectionHandle) => {
  Sentry.addBreadcrumb({
    category: "events",
    message: "viewCollectionEvent",
    data: {
      collectionHandle,
    },
    level: "info",
  });

  nostojs((api) => {
    api
      .defaultSession()
      .viewCategory(collectionHandle)
      .setPlacements(api.placements.getPlacements())
      .load()
      .then((data) => {
        console.log(data.recommendations);
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
      });
  });
};

export const searchEvent = async (searchQuery) => {
  console.log("nostoSearchQuery", searchQuery);
  // eslint-disable-next-line no-undef
  nostojs((api) => {
    api
      .defaultSession()
      .viewSearch(searchQuery)
      .setPlacements(["searchpage-nosto-1", "searchpage-nosto-2"])
      .load()
      .then((data) => {
        console.log(data.recommendations);
      });
  });
};

export const view404Event = async () => {
  // eslint-disable-next-line no-undef
  nostojs((api) => {
    api
      .defaultSession()
      .viewNotFound()
      .setPlacements(api.placements.getPlacements())
      .load()
      .then((data) => {
        console.log(data.recommendations);
      });
  });
};

export const viewGeneralPageEvent = async () => {
  // eslint-disable-next-line no-undef
  nostojs((api) => {
    api
      .defaultSession()
      .viewOther()
      .setPlacements(api.placements.getPlacements())
      .load()
      .then((data) => {
        console.log(data.recommendations);
      });
  });
};

export const registerEvent = async ({ method, email }) => {
  window.dataLayer.push({
    event: "sign_up",
    method,
  });
  fbq("track", "Complete Registration Success");

  try {
    const utmDetails = localStorage.getItem("shopifyUTMDetails");
    if (!utmDetails) {
      return;
    }

    const parsedUtmDetails = JSON.parse(utmDetails);

    const body = {
      email,
      ...(parsedUtmDetails.utmCampaign
        ? { utmCampaign: parsedUtmDetails.utmCampaign }
        : {}),
      ...(parsedUtmDetails.utmSource
        ? { utmSource: parsedUtmDetails.utmSource }
        : {}),
    };

    await fetch(process.env.RATANDBOA_NODE_APP_URL + "/event/register", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  } catch (error) {
    console.log(error);
    Sentry.captureException(error);
  }
};

export const smsCaptureEvent = ({ location }) => {
  window.dataLayer.push({
    event: "sms_capture",
    location,
  });
};

export const birthdayCaptureEvent = ({ location }) => {
  window.dataLayer.push({
    event: "birthday_capture",
    location,
  });
};

export const loginEvent = ({ method }) => {
  window.dataLayer.push({
    event: "login",
    method,
  });
};

export const addToWishlistEvent = ({ product }) => {
  const amount = product.priceRange.minVariantPrice.amount;
  const currency = product.priceRange.minVariantPrice.currencyCode;
  const firstVariant = unwrapNodes(product.variants.edges)[0];

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "add_to_wishlist",
    ecommerce: {
      currency: currency,
      value: amount,
      items: [
        {
          item_id: `shopify_US_${product.id.split("Product/")[1]}_${
            firstVariant.id.split("ProductVariant/")[1]
          }`,
          item_name: product.title,
          item_brand: product.vendor,
          item_category: product.productType,
          item_variant: firstVariant.title,
          price: amount,
          quantity: 1,
        },
      ],
    },
  });
};

export const bisEvent = () => {
  window.dataLayer.push({
    event: "bis_signup",
  });

  window.VWO = window.VWO || [];
  VWO.event =
    VWO.event ||
    function () {
      VWO.push(["event"].concat([].slice.call(arguments)));
    };
  VWO.event("bis_signup", {
    added_to_cart: true,
  });
};
